import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopMenu from '../../contexts/TopMenu';
import '../../styles/Fulfillment.css';  // Reusing the existing styles
import '../../styles/Admin.css';  // Add the Admin-specific styles

function Admin({ email, onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="dashboard-root">
      <TopMenu pageTitle="Admin Panel" email={email} onLogout={onLogout} />
      <div className="dashboard-container">
        <div className="admin-sections">
          {/* Engagement Section */}
          <div className="admin-category">
            <h3 className="category-title">Engagement</h3>
            <div className="admin-cards">
              <div className="admin-card">
                <h4>Celebrities</h4>
                <p>Manage celebrity personas, styling references & embeddings</p>
                <button 
                  className="zara-button"
                  onClick={() => navigate('/celebs')}
                >
                  Manage Celebrities
                </button>
              </div>

              <div className="admin-card">
                <h4>Brands Onboarding</h4>
                <p>Track onboarding status, domains, policies & daily sync</p>
                <button 
                  className="zara-button"
                  onClick={() => navigate('/brands')}
                >
                  Onboarding Manager
                </button>
              </div>
            </div>
          </div>

          {/* Finance Section */}
          <div className="admin-category">
            <h3 className="category-title">Finance</h3>
            <div className="admin-cards">
              <div className="admin-card">
                <h4>Brand Payouts</h4>
                <p>View and manage brand payouts and records</p>
                <button 
                  className="zara-button"
                  onClick={() => window.location.href = '/admin/payouts'}
                >
                  Go to Payouts
                </button>
              </div>
              <div className="admin-card">
                <h4>Revenues</h4>
                <p>Track revenue and sales performance data</p>
                <button 
                  className="zara-button"
                  disabled={true}
                  onClick={() => window.location.href = '/admin/revenues'}
                >
                  Go to Revenues
                </button>
              </div>
              <div className="admin-card">
                <h4>Refunds</h4>
                <p>Track refund and return statuses of customer returns</p>
                <button 
                  className="zara-button"
                  disabled={true}
                  onClick={() => window.location.href = '/admin/refunds'}
                >
                  Go to Refunds
                </button>
              </div>
              <div className="admin-card">
                <h4>Taxes</h4>
                <p>Track GST, TCS liabilities and payments</p>
                <button 
                  className="zara-button"
                  disabled={true}
                  onClick={() => window.location.href = '/admin/taxes'}
                >
                  Go to Taxes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin; 